import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { Box, Fab, Zoom } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";

const FloatingActionButton = ({ isMobile, href, label, icon }) => {
    const [visible, setVisible] = useState(false);

  // Manejar el evento de scroll
  const handleScroll = () => {
    if (window.scrollY > 500) {
      setVisible(true);
    } else {
      setVisible(false);
    }
  };

   // Añadir y limpiar el evento de scroll
   useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <Box
      sx={{
        position: "fixed",
        bottom: "16px",
        right: isMobile ? "" : "86px",
        left: isMobile ? "16px" : "",
        zIndex: 1000,
      }}
    >
        <Zoom in={visible}>
      <Fab
        href={href}
        target="_blank"
        color="primary"
        aria-label="descargar"
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          paddingLeft: "16px",
          width: "56px", // Tamaño inicial
          transition: "all 0.3s ease-in-out",
          overflow: "hidden",
          "&:hover": !isMobile
            ? {
                width: "200px", // Tamaño expandido
                height: "56px",
                borderRadius: "33px",
              }
            : null, // Sin hover en móviles
        }}
      >
        {icon || <DownloadIcon sx={{ marginRight: "8px" }} />}
        {!isMobile && (
          <Box
            component="span"
            sx={{
              marginLeft: "8px",
              fontSize: "14px",
              whiteSpace: "nowrap",
            }}
          >
            {label}
          </Box>
        )}
      </Fab>
      </Zoom>
    </Box>
  );
};

FloatingActionButton.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  href: PropTypes.string.isRequired,
  label: PropTypes.string,
  icon: PropTypes.node,
};


export default FloatingActionButton;
